import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ChanceNodeLogDto, PublicStore, StoresService } from "@api";
import { InfiniteScrollCustomEvent, ModalController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { RootState } from "src/app/store";
import * as ScenarioActions from "src/app/store/scenario/actions";
import * as FromScenario from "src/app/store/scenario/selectors";
import * as FromRouter from "src/app/store/router/selectors";
import { first } from "rxjs/operators";
import { LOGS_PER_PAGE } from "src/app/constants";

@Component({
  selector: "app-scenario-logs",
  templateUrl: "./scenario-logs.page.html",
  styleUrls: ["./scenario-logs.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScenarioLogsPage implements OnInit {
  @Input() public runId: number;
  @Input() public chanceNodeId: string;

  public loading$: Observable<boolean> = this.store.select(FromScenario.getLoading);
  public logs$: Observable<ChanceNodeLogDto[]>;
  public currentLogsPage$: Observable<number>;
  public currentLogsTotalPages$: Observable<number>;
  public severities: typeof ChanceNodeLogDto.SeverityEnum = ChanceNodeLogDto.SeverityEnum;
  public stores$?: Observable<PublicStore[]>;
  public selectedStoreId?: string;

  constructor(private store: Store<RootState>, private modalController: ModalController, private storeService: StoresService) {}

  public async ngOnInit(): Promise<void> {
    this.stores$ = this.storeService.storeControllerGetPublic({ searchTerm: "" });

    if (this.runId) {
      this.refresh();
      this.logs$ = this.store.select(FromScenario.getScenarioRunLogs(this.runId));
      this.currentLogsPage$ = this.store.select(FromScenario.getScenarioRunLogsCurrentPage(this.runId));
      this.currentLogsTotalPages$ = this.store.select(FromScenario.getScenarioRunLogsTotalPages(this.runId));
    }
  }

  public dismiss(): void {
    this.modalController.dismiss();
  }

  public loadMoreLogs(event: InfiniteScrollCustomEvent): void {
    this.currentLogsPage$.pipe(first()).subscribe(currentPage =>
      this.store.dispatch(
        ScenarioActions.getScenarioRunLogs({
          chanceNodeId: this.chanceNodeId,
          runId: this.runId,
          page: currentPage + 1,
          limit: LOGS_PER_PAGE,
          event,
        }),
      ),
    );
  }

  public runScenario(): void {
    this.store
      .select(FromRouter.selectScenarioId)
      .pipe(first())
      .subscribe(chanceNodeId => {
        this.store.dispatch(ScenarioActions.cleanRunLogs({ chanceNodeId }));
        this.store.dispatch(ScenarioActions.runScenario({ chanceNodeId, storeId: this.selectedStoreId }));
        this.logs$ = this.store.select(FromScenario.getScenarioRunLogs(0));
      });
  }

  private refresh(): void {
    this.store.dispatch(
      ScenarioActions.getScenarioRunLogs({ chanceNodeId: this.chanceNodeId, runId: this.runId, page: 1, limit: LOGS_PER_PAGE }),
    );
  }
}
